import styled from "styled-components";
import { getWindowHeight } from "../../utils";

const FallbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  align-items: center;
  height: ${getWindowHeight()};
  width: 100vw;
`;

export default FallbackContainer;
